export const OCC_ENDPOINTS = {
  paymentDetailsAll: 'current-user/paymentdetails',
  paymentDetails: 'current-user/paymentdetails/${bindingId}',
  paymentDetailsBinding: 'current-user/carts/${cartId}/paymentdetails',
  initCardBinding: 'current-user/paymentdetails/init-card-binding',
};
